import { useMutation } from '@tanstack/react-query';

import { authApi } from '../api/auth-api';

/** Always 202 for a well-formed email; the page never learns whether the account exists. */
export function useForgotPassword() {
  return useMutation({ mutationFn: authApi.forgotPassword, meta: { silentError: true } });
}
